<!-- <p>send-reports-email-dialog works!</p> -->
<div *ngIf="data.isSending">
  <h1 mat-dialog-title>Sending Reports</h1>
  <mat-dialog-content class="mat-typography">
    <!-- {{ data | json }} -->
    <div class="add-user-dialog-status">
      <i>Please wait!</i>
      <mat-spinner></mat-spinner>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
</div>

<div *ngIf="data.isFailed && false">
  <h1 mat-dialog-title>Reports Send Failed</h1>
  <mat-dialog-content class="mat-typography">
    <!-- {{ data | json }} -->
    <div class="add-user-dialog-status">
      <i>Error!</i>
      <mat-spinner></mat-spinner>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
<div *ngIf="data.isSuccess">
  <h1 mat-dialog-title>Reports Send Success</h1>
  <mat-dialog-content class="mat-typography">
    <!-- {{ data | json }} -->
    <div class="add-user-dialog-status">
      <i>Your report data has been sent!</i>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
